var map = {
	"./CO2 Plant.png": 571,
	"./CO2StorageTank.png": 1717,
	"./Chemical.png": 5,
	"./ColdStorage.png": 1597,
	"./MilkTanker.png": 147,
	"./Pharmascutical.png": 5909,
	"./services": 6638,
	"./services.json": 6638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7685;